import { ɵɵdefineInjectable, ɵɵinject, Injectable, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { from, EMPTY } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';

// Package Imports
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/router';
class CdbHttpClientService {
    constructor(http, router) {
        this.http = http;
        this.router = router;
        this.loadingCount = 0;
        this.defaultOptions = {
            headers: new HttpHeaders({ 'content-type': 'application/json', 'cache-control': 'no-cache', pragma: 'no-cache' }),
            responseType: 'json'
        };
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    get(url, bearerToken, options) {
        this.addLoadingWait();
        return from(this.generateOptions(options, this.defaultOptions, bearerToken)).pipe(mergeMap(newOptions => this.http.get(url, newOptions).pipe(map(res => {
            this.removeLoadingWait();
            return res;
        })))).pipe(catchError((error) => {
            this.trapError(error);
            return EMPTY;
        }));
    }
    post(url, data, bearerToken, options) {
        this.addLoadingWait();
        return from(this.generateOptions(options, this.defaultOptions, bearerToken)).pipe(mergeMap(newOptions => this.http.post(url, data, newOptions).pipe(map(res => {
            this.removeLoadingWait();
            return res;
        })))).pipe(catchError((error) => {
            this.trapError(error);
            return EMPTY;
        }));
    }
    put(url, data, bearerToken, options) {
        this.addLoadingWait();
        return from(this.generateOptions(options, this.defaultOptions, bearerToken)).pipe(mergeMap(newOptions => this.http.put(url, data, newOptions).pipe(map(res => {
            this.removeLoadingWait();
            return res;
        })))).pipe(catchError((error) => {
            this.trapError(error);
            return EMPTY;
        }));
    }
    delete(url, bearerToken, data, options) {
        this.addLoadingWait();
        if (data) {
            options.body = data;
        }
        return from(this.generateOptions(options, this.defaultOptions, bearerToken)).pipe(mergeMap(newOptions => this.http.delete(url, newOptions).pipe(map(res => {
            this.removeLoadingWait();
            return res;
        })))).pipe(catchError((error) => {
            this.trapError(error);
            return EMPTY;
        }));
    }
    postForm(url, data, bearerToken, options) {
        this.addLoadingWait();
        return from(this.generateOptionsWithDefault(options, bearerToken)).pipe(mergeMap(newOptions => this.http.post(url, data, newOptions).pipe(map(res => {
            this.removeLoadingWait();
            return res;
        })))).pipe(catchError((error) => {
            this.trapError(error);
            return EMPTY;
        }));
    }
    generateOptionsWithDefault(options, bearerToken) {
        const promise = new Promise((resolve) => {
            this.appendOptionsByUserId({ headers: new HttpHeaders({ 'cache-control': 'no-cache', pragma: 'no-cache' }) }, bearerToken)
                .then(defaultOptions => {
                if (!options) {
                    const result = { headers: defaultOptions.headers, responseType: defaultOptions.responseType };
                    this.appendOptionsByUserId(result, bearerToken).then(r => resolve(r));
                }
                else {
                    const { headers = defaultOptions.headers, responseType = defaultOptions.responseType, params = null } = options;
                    this.appendOptionsByUserId({ headers, responseType, params }, bearerToken)
                        .then(r => resolve(r));
                }
            });
        });
        return promise;
    }
    generateOptions(options, defaultOptions, bearerToken) {
        const promise = new Promise((resolve) => {
            if (!options) {
                const result = { headers: defaultOptions.headers, responseType: defaultOptions.responseType };
                this.appendOptionsByUserId(result, bearerToken).then(r => resolve(r));
            }
            else {
                const { headers = defaultOptions.headers, responseType = defaultOptions.responseType, params = null } = options;
                this.appendOptionsByUserId({ headers, responseType, params }, bearerToken)
                    .then(r => resolve(r));
            }
        });
        return promise;
    }
    appendOptionsByUserId(options, bearerToken) {
        const promise = new Promise((resolve) => {
            if (!options || !options.headers) {
                if (!options.headers.has('Authorization')) {
                    options.headers = options.headers.append('Authorization', bearerToken);
                    resolve(options);
                }
                else {
                    resolve(options);
                }
            }
            if (!options.headers.has('Authorization')) {
                options.headers = options.headers.append('Authorization', bearerToken);
                resolve(options);
            }
            else {
                resolve(options);
            }
        });
        return promise;
    }
    trapError(error) {
        this.removeLoadingWait();
        switch (error.status) {
            case 401:
            case 403:
                this.router.navigate([`/unauthorized/${error.status}`]);
                break;
            default:
                throw error;
        }
    }
    // the cursor changes to a spinning wheel/ hour glass
    addLoadingWait() {
        this.loadingCount++;
        document.body.style.cursor = 'wait';
    }
    // once all the loading calls have returned change the cursor back to default
    removeLoadingWait() {
        this.loadingCount--;
        if (this.loadingCount <= 0) {
            document.body.style.cursor = 'default';
            this.loadingCount = 0;
        }
    }
}
CdbHttpClientService.ɵfac = function CdbHttpClientService_Factory(t) { return new (t || CdbHttpClientService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
CdbHttpClientService.ɵprov = ɵɵdefineInjectable({ factory: function CdbHttpClientService_Factory() { return new CdbHttpClientService(ɵɵinject(HttpClient), ɵɵinject(Router)); }, token: CdbHttpClientService, providedIn: "root" });
CdbHttpClientService.ctorParameters = () => [
    { type: HttpClient },
    { type: Router }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CdbHttpClientService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.Router }]; }, null); })();

// Third Party Imports
class CdbHttpClientModule {
}
CdbHttpClientModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CdbHttpClientModule });
CdbHttpClientModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CdbHttpClientModule_Factory(t) { return new (t || CdbHttpClientModule)(); }, providers: [
        CdbHttpClientService
    ], imports: [[]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CdbHttpClientModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                exports: [],
                providers: [
                    CdbHttpClientService
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of cdb-http-client
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CdbHttpClientModule, CdbHttpClientService };

//# sourceMappingURL=cdb-http-client.js.map